const NonProfitView = {
  List: 'byCause',
  Grid: 'grid',
};

const createNonProfitSlice = (set, get) => ({
  nonProfit: {
    initialized: false,
    cached: {},
    loading: {},
    filteredRowItems: [],
    filteredNonProfitIds: [],
    causeCategories: [],
    causeCategoryFilterOptions: [],
    stateFilterOptions: [],
    zipCodeFilterOptions: [],
    filters: {
      onlyFromMyState: false,
      includeForeign: false,
      onlyClaimed: false,
      causes: [],
      country: '',
      searchText: "",
    },
    topDonors: [],
    view: NonProfitView.List,
    hasMore: true,
    page: 0,
  }
});

export { createNonProfitSlice as default, NonProfitView };
